import React, { Component } from 'react';
import { DataAPIBaliseRetour } from '../../data/DataAPIBaliseRetour';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxAPIBaliseRetour extends Component {

    static defaultProps = {
        idAPI: undefined,
        idAPIBaliseRetour: undefined, // Si renseignée, est exclue de la CB (pour éviter qu'une balise ne devienne l'enfant d'elle-même)
        label: "Balise",
        placeholder: "Balise",
    };

    render = () => {

        const { idAPI, idAPIBaliseRetour } = this.props;

        return <EUIComboBox
            {...this.props}
            fetchMethod={() => DataAPIBaliseRetour._chargementAPIBalisesRetour({ idAPI }, "LibelleBaliseRetour")}
            itemHidden={item => item.idAPIBaliseRetour === idAPIBaliseRetour}
            itemKey={item => item.idAPIBaliseRetour}
            itemText={item => item.libelleBaliseRetour}
            stamp={idAPI}
        />;

    };

};